import { Component, EventEmitter, forwardRef, inject, input, Output } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';
import { PickListSourceFilterEvent } from 'primeng/picklist';
import { AppConfig } from 'src/app/app-config.loader';
import { AnagraficaIndirizziService } from 'src/app/core/anagrafica-indirizzi.service';
import { Indirizzo } from 'src/app/shared/models/indirizzo.model';

@Component({
  selector: 'app-dati-documento-destinatari',
  template: `
    <input pInputText type="text" [placeholder]="destinatariSelection.length + ' Destinatari selezionati'" *ngIf="destinatariSelection.length > 1" disabled>
    <p-autoComplete *ngIf="destinatariSelection.length <= 1" [appAnagraficaAutocomplete]="AnagraficaIndirizziService" [style]="{ 'width': 'calc(' + width() + ' - 40px)'}"
      [ngModel]="destinatariSelection[0]?.nomeIndirizzo" (onClear)="destinatarioSelected(null)" (onSelect)="destinatarioSelected($event.value)"
      (anagraficaItemsChanged)="itemsChanged($event)" appendTo="body">
    </p-autoComplete>

    <p-button [styleClass]="'button-class'" icon="fas fa-list" (onClick)="showPicklist()" novalidate></p-button>

  <p-dialog header="Seleziona Destinatari" [(visible)]="showPicklistDialog" [modal]="true" appendTo="body" [style]="{width: '75vw', height: '75vh'}">
    <div class="add-destinatario" style="margin-bottom: 7px;">
      <div class="grid">
      <!--div class="ui-g-6"></div-->
        <div class="col-6 p-inputgroup">
          <input type="text" pInputText placeholder="Nuovo Destinatario" [(ngModel)]="newDestinatario">
          <button pButton type="button" icon="pi pi-plus" class="p-button-warn" title="Aggiungi Destinatario"
          (click)="addNuovoIndirizzo()"></button>
        </div>
      </div>
    </div>
    @if (showPicklistDialog) {
      <p-pickList [dragdrop]="true" filterBy="nomeIndirizzo"
        [source]="destinatariListSource" sourceHeader="Disponibili" [showSourceFilter]="true" [showSourceControls]="false"
        [target]="destinatariSelection" targetHeader="Selezionati" [showTargetFilter]="true" [showTargetControls]="false"
        [trackBy]="picklistTrackBy" sourceFilterPlaceholder="Inserisci almeno 4 caratteri per filtrare i risultati"
        (onMoveToSource)="moveToSource($event, destinatariListSource)" (onMoveAllToSource)="sortOnListChange(destinatariListSource)"
        (onMoveToTarget)="sortOnListChange(destinatariSelection)" (onMoveAllToTarget)="sortOnListChange(destinatariSelection)" (onSourceFilter)="filterSource($event)"
        [style]="{ height: '80%' }"
        [sourceStyle]="{ height: '100%', overflow: 'auto' }" [targetStyle]="{ height: '100%', overflow: 'auto' }">
        <ng-template let-dest pTemplate="item">
          <div>{{dest?.nomeIndirizzo}}</div>
        </ng-template>
      </p-pickList>
    }
    <p-footer>
      <button pButton type="button" icon="pi pi-times" label="Annulla" (click)="cancelPickList()"
      class="p-button-secondary"></button>
      <button pButton type="button" icon="pi pi-check" label="Seleziona" (click)="confirmPickList()"
      [disabled]="false"></button>
    </p-footer>
    </p-dialog>
    `,
  styles: [`
    :host ::ng-deep .p-picklist .p-picklist-list { width: auto; height: 40vh; }
    :host ::ng-deep button[icon="pi pi-angle-double-right"], :host ::ng-deep button[icon="pi pi-angle-double-left"] { display: none; }
    `],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DestinatariComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => DestinatariComponent),
      multi: true
    }
  ]
})
export class DestinatariComponent implements ControlValueAccessor, Validator {
  width = input<string>('100%');

  @Output() public addIndirizzo = new EventEmitter<string | null>();

  private readonly appConfig = inject(AppConfig);

  public indirizzi: Indirizzo[] = [];
  public indirizziSelection: Indirizzo[] = [];
  public destinatariSelection: Indirizzo[] = [];
  public destinatariOriginalSelection: Indirizzo[] = [];
  public destinatariListSource: Indirizzo[] = [];
  public destinatariFiltered: Indirizzo[] = [];
  public newDestinatario: string | null = null;
  public showPicklistDialog = false;
  public AnagraficaIndirizziService = AnagraficaIndirizziService;

  private onChangeFn!: (_: Indirizzo[]) => void;
  private onTouchedFn!: () => void;
  private lastQuery = '';

  private readonly NUM_MAX_RESULT_ITEMS = this.appConfig.settings.maxResultItems;

  writeValue(value: Indirizzo[]): void {
    const idList = value;

    this.destinatariSelection = [];
    if (idList && idList.length > 0) {
      this.destinatariListSource = [];
      this.destinatariSelection = this.indirizzi.filter(i => idList.some(l => l.indirizzoId === i.indirizzoId));
    } else {
      this.destinatariListSource = [];
    }
  }

  registerOnChange(fn: (_: unknown) => void): void {
    this.onChangeFn = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouchedFn = fn;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    const value = control.value as number[];
    return value && value.length > 0 ? null : { required: true };
  }

  destinatarioSelected(value: Indirizzo | null): void {
    if (value) {
      const indirizzo = this.indirizzi.find(i => i.indirizzoId === value.indirizzoId);
      this.destinatariSelection = indirizzo ? [indirizzo] : [];
      this.onChangeFn(this.destinatariSelection);
    } else {
      this.destinatariSelection = [];
      this.onChangeFn([]);
    }
  }

  showPicklist(): void {
    this.destinatariListSource = [];
    this.destinatariOriginalSelection = [...this.destinatariSelection];
    // this.destinatariListSource = this.destinatariSelection.length > 0 ? this.indirizzi.filter(d => !this.destinatariSelection.some(ds => d.indirizzoId === ds.indirizzoId)) : [...this.indirizzi];
    this.newDestinatario = null;
    this.showPicklistDialog = true;
    this.lastQuery = '';
  }

  confirmPickList(): void {
    this.showPicklistDialog = false;
    this.onChangeFn(this.destinatariSelection);
  }

  cancelPickList(): void {
    this.destinatariSelection = this.destinatariOriginalSelection;
    this.showPicklistDialog = false;
  }

  sortOnListChange(list: Indirizzo[]): void {
    sortIndirizzi(list);
  }

  moveToSource(event: { items: Indirizzo[] }, list: Indirizzo[]): void {
    this.destinatariListSource = sortIndirizzi(list.filter((i => !event.items.includes(i))));
  }

  addNuovoIndirizzo(): void {
    this.addIndirizzo.emit(this.newDestinatario);
  }

  itemsChanged(ind: Indirizzo[]): void {
    this.indirizzi = ind;

    if (this.newDestinatario) {
      const indirizzo = ind.find(i => i.nomeIndirizzo === this.newDestinatario);
      this.destinatariSelection.push(indirizzo!);
      this.showPicklist();
    }
  }

  picklistTrackBy(index: number, item: Indirizzo): number | undefined {
    return item.indirizzoId;
  }

  filterSource(event: PickListSourceFilterEvent): void {
    const e = event;
    const upperQuery = e.query?.toUpperCase();
    if (typeof upperQuery === 'undefined') return;

    if (this.lastQuery !== upperQuery) {
      this.lastQuery = upperQuery;
      if (upperQuery.length > 3) {
        this.destinatariListSource = [];
        this.destinatariListSource = this.indirizzi.filter(i => i.nomeIndirizzo.toUpperCase().indexOf(upperQuery) !== -1).slice(0, this.NUM_MAX_RESULT_ITEMS);

        // workaround to trigger filter on picklist
        setTimeout(() => {
          document.querySelectorAll('.p-picklist-source-wrapper .p-picklist-filter-input')[0].dispatchEvent(new KeyboardEvent('keyup', { 'key': '' }));
        }, 10);

      } else {
        this.destinatariListSource = [];
      }
    }
  }
}

export function sortIndirizzi(indirizzi: Indirizzo[]): Indirizzo[] {
  indirizzi?.sort((a, b) => a.nomeIndirizzo.localeCompare(b.nomeIndirizzo, undefined, { sensitivity: 'base' }));
  return indirizzi;
}
